import { Injectable } from '@angular/core';
import { Observable, tap } from 'rxjs';
import { PreferencesService } from '../../../preferences/preferences-service/preferences.service';
import { TPreferences } from '../../../preferences/preferences.model';
import { ResetTableService } from '../../reset-table.service';
import { CustomTableService } from '../../site-table/custom-table/custom-table.service';

@Injectable({
  providedIn: 'root',
})
export class ResetTimelineService {
  constructor(
    private resetTableService: ResetTableService,
    private preferencesService: PreferencesService,
    private customTableService: CustomTableService,
  ) {}

  resetTimeline(): void {
    this.resetTableService.resetFilters();
    this.resetTimeframeAndGroup().subscribe();
  }

  private resetTimeframeAndGroup(): Observable<TPreferences> {
    const body: Partial<TPreferences> = {
      timeline: {
        timeframe: null,
        group: null,
      },
    };

    return this.preferencesService.updatePreferences(body).pipe(
      tap(() => {
        this.customTableService.reloadTable();
      }),
    );
  }
}
